var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDamage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13505_15045)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5295 13.3003C10.6318 14.0693 11.6961 16.3529 10.9066 18.4007C10.1172 20.4486 7.77296 21.4854 5.67066 20.7163C3.56836 19.9473 2.50409 17.6638 3.29354 15.6159C4.08299 13.568 6.42721 12.5313 8.5295 13.3003ZM9.44659 10.9213C12.8977 12.1837 14.6447 15.9323 13.3488 19.2941C12.0529 22.6558 8.20466 24.3577 4.75358 23.0953C1.3025 21.8329 -0.444583 18.0843 0.851355 14.7225C2.14729 11.3608 5.99551 9.65893 9.44659 10.9213Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8826 10.9625C24.6086 11.228 25.0806 11.9143 25.0565 12.6694L25.0468 12.9729L17.272 10.1289L17.2874 8.53944C17.2931 7.95469 16.8111 7.47616 16.2109 7.47061C15.6106 7.46506 15.1193 7.93459 15.1136 8.51934L15.1044 9.46216C14.8977 9.48595 14.6987 9.56743 14.5337 9.70224L6.67708 16.1177C6.38092 16.3595 6.23885 16.7364 6.30393 17.1074C6.36901 17.4785 6.63145 17.788 6.99324 17.9204L15.7055 21.1073C16.0376 21.2288 16.4097 21.1847 16.7023 20.9893C16.9949 20.7939 17.1712 20.4717 17.1745 20.1261L17.25 12.3829L24.957 15.2021L24.4872 22.1158C24.4543 22.6996 24.9135 23.199 25.5129 23.2311C26.1123 23.2632 26.6249 22.8159 26.6579 22.232L27.1293 15.2884C27.1435 15.2253 27.152 15.16 27.1541 15.093L27.1724 14.5191L27.1726 14.5145L27.2294 12.7352C27.2824 11.074 26.2441 9.56425 24.6469 8.98L24.5544 8.94616C23.9924 8.74058 23.3657 9.01772 23.1547 9.56517C22.9436 10.1126 23.2281 10.7231 23.7901 10.9286L23.8826 10.9625ZM15.0795 12.0198L15.0155 18.5928L9.50045 16.5755L15.0795 12.0198Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3386 8.16934C19.5496 7.62189 19.2651 7.01145 18.7031 6.80587L14.6328 5.31697C14.0708 5.11139 13.4442 5.38853 13.2331 5.93598C13.0221 6.48342 13.3066 7.09387 13.8686 7.29944L17.9389 8.78835C18.5009 8.99393 19.1275 8.71679 19.3386 8.16934Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7352 14.6183C26.4528 14.1023 25.7944 13.907 25.2647 14.1821L15.9851 19.0015C15.4553 19.2766 15.2549 19.9179 15.5373 20.434C15.8197 20.95 16.4781 21.1453 17.0078 20.8701L26.2874 16.0508C26.8172 15.7757 27.0176 15.1343 26.7352 14.6183Z",
    fill: "#B1B0F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13505_15045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamage);
export default __webpack_public_path__ + "static/media/damage.54ee44fc906585acf5cad592c431b27d.svg";
export { ForwardRef as ReactComponent };